/** Van-Vorlagen: Innenmaße als Näherungswerte (bitte am Fahrzeug prüfen), in Metern. */
export interface VanTemplate {
  id: string;
  name: string;
  length: number;
  width: number;
  height: number;
  /** Radkästen: lichte Breite zwischen ihnen, Länge, Höhe, Abstand der Vorderkante zur Rückwand. */
  wheelArch?: { clearance: number; length: number; height: number; fromRear: number };
}

export const VAN_TEMPLATES: VanTemplate[] = [
  { id: 'custom', name: 'Eigener Hohlraum', length: 4.0, width: 1.8, height: 1.9 },
  {
    id: 'sprinter-l3h2', name: 'Mercedes Sprinter L3H2 (Hochdach, lang)',
    length: 4.7, width: 1.78, height: 1.93,
    wheelArch: { clearance: 1.35, length: 1.1, height: 0.26, fromRear: 0.25 }
  },
  {
    id: 'sprinter-l2h2', name: 'Mercedes Sprinter L2H2 (mittel)',
    length: 3.55, width: 1.78, height: 1.66,
    wheelArch: { clearance: 1.35, length: 1.1, height: 0.26, fromRear: 0.25 }
  },
  {
    id: 'transit-l3h3', name: 'Ford Transit L3H3 (Hochdach)',
    length: 4.17, width: 1.78, height: 2.1,
    wheelArch: { clearance: 1.4, length: 1.2, height: 0.3, fromRear: 0.3 }
  },
  {
    id: 'crafter-l3h3', name: 'VW Crafter L3H3 / MAN TGE',
    length: 4.69, width: 1.78, height: 2.14,
    wheelArch: { clearance: 1.38, length: 1.15, height: 0.28, fromRear: 0.3 }
  },
  {
    id: 'ducato-l4h3', name: 'Fiat Ducato L4H3',
    length: 4.07, width: 1.78, height: 2.1,
    wheelArch: { clearance: 1.42, length: 1.15, height: 0.3, fromRear: 0.3 }
  },
  { id: 't6-l2h1', name: 'VW T6.1 L2H1 (kompakt)', length: 2.8, width: 1.7, height: 1.41 },
  { id: 'vito-l2', name: 'Mercedes Vito L2 (kompakt)', length: 2.79, width: 1.65, height: 1.41 }
];

export function templateById(id: string): VanTemplate {
  return VAN_TEMPLATES.find((t) => t.id === id) ?? VAN_TEMPLATES[0]!;
}

/** Aktuelle Van-Konfiguration der App. */
export interface VanState {
  templateId: string;
  /** Individualisierte Maße (m), editierbar im Panel. */
  length: number;
  width: number;
  height: number;
  visible: boolean;
  arches: boolean;
}
